<!-- 聊天列表 -->
<template>
  <div class="msglist">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-state">
      <p>加载中...</p>
    </div>

    <!-- 错误提示 -->
    <div v-else-if="error" class="error-state">
      <p class="error-message">{{ error }}</p>
      <button class="retry-btn" @click="loadChatlist">重试</button>
    </div>

    <!-- 正常列表 -->
    <ul v-else class="chat-ul">
      <li v-for="item in searchedChatlist" :key="item.id" class="sessionlist" ,
        :class="{ active: (item.userId || item.userid) === selectId }"
        @click="selectSession(item.userId || item.userid)">
     <div class="itemlist">
         <div class="list-left">
          <div v-if="!item.photo" class="avatar avatar-text"
            :style="{ backgroundColor: getRandomAvatarColor(item.id) }">
            {{ (item.firstName || item.userName)[0] || '用' }}
          </div>
          <img v-else class="avatar" width="42" height="42" :alt="item.userName" :src="item.photo">
          <span v-if="item.unreadMessage > 0" class="unread-count"></span>
        </div>
        <div class="list-right">
          <div class="top-row">
            <p class="name">
              {{ item.firstName || item.userName }}
              <!-- <span v-if="item.status_dictText" class="status">{{ item.status_dictText }}</span> -->
            </p>

          </div>
          <div class="top-row">
            <p v-if="item.unreadMessage" class="lastmsg">{{ item.lastMessage || '暂无消息' }}</p>
            <span class="time">{{ item.updateTime | time }}</span>

          </div>

        </div>
     </div>
      </li>
      <!-- 空状态提示 -->
      <li v-if="searchedChatlist.length === 0" class="empty-state">
        <div class="empty-content">
          <p>{{ searchText ? '没有找到匹配的会话' : '暂无会话' }}</p>
        </div>
      </li>
      <!-- 加载更多按钮 -->
      <li v-if="!searchText && pagination.hasMore && searchedChatlist.length > 0 && !loadingMore" class="load-more">
        <button @click="loadMoreChatlist" class="load-more-btn">加载更多</button>
      </li>
      <!-- 加载更多中状态 -->
      <li v-if="loadingMore" class="loading-more">
        <p>加载更多中...</p>
      </li>
    </ul>

    <!-- 底部演示随机显示 -->

  </div>
</template>

<script>
import { getRequestParams, decodeFromBase64 } from '@/utils/getPrams.js';
import api from '../../api/api'
export default {
  data() {
    return {
      authObj: null,
      chatlist: [],
      selectId: '',
      searchText: '',
      error: null,
      loading: false,
      showDemo: Math.random() > 0.5, // 随机显示底部演示
      avatarColors: [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
        '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
        '#BB8FCE', '#85C1E2', '#F8C471', '#82E0AA'
      ],
      // 分页相关
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        hasMore: true
      },
      loadingMore: false,
      chatlistPollingInterval: null,
      chatlistPollingIntervalTime: 5000 // 5秒轮询一次
    }
  },
  created() {
    //console.log('chatlist.vue - created');
    const urlParams = getRequestParams();
    if (urlParams) {
      this.loadChatlist()
    } else {
      localStorage.removeItem('sx-token');
      localStorage.removeItem('isLoggedIn');
    }

  },
  mounted() {
    // 监听父组件传递的搜索事件
    this.$parent.$on('search-change', (searchText) => {
      this.searchText = searchText
    })
    // 启动轮询
    this.startChatlistPolling();
  },
  beforeDestroy() {
    // 停止轮询
    this.stopChatlistPolling();
  },
  computed: {
    searchedChatlist() {
      if (!this.searchText) return this.chatlist
      return this.chatlist.filter(item => {
        const userName = item.userName || ''
        const firstName = item.firstName || ''
        return userName.toLowerCase().includes(this.searchText.toLowerCase()) ||
          firstName.toLowerCase().includes(this.searchText.toLowerCase())
      })
    }
  },
  methods: {


    // 启动聊天列表轮询
    startChatlistPolling() {
      // 清除之前的定时器
      this.stopChatlistPolling();

      // 启动新的轮询
      this.chatlistPollingInterval = setInterval(() => {
        this.loadChatlist(false, true); // 传入isPolling=true，轮询时不显示加载状态
      }, this.chatlistPollingIntervalTime);
    },

    // 停止聊天列表轮询
    stopChatlistPolling() {
      if (this.chatlistPollingInterval) {
        clearInterval(this.chatlistPollingInterval);
        this.chatlistPollingInterval = null;
      }
    },

    loadChatlist(isLoadMore = false, isPolling = false) {
      // 请求开始时设置loading状态，清除之前的错误
      if (isLoadMore) {
        this.loadingMore = true;
      } else if (!isPolling) { // 只有非轮询时才显示加载状态
        this.loading = true;
        this.pagination.currentPage = 1;
        this.pagination.hasMore = true;

      }
      try {
        this.error = null;
        const urlParams = getRequestParams();

        // 2. 解析为 JSON 对象（让数据更易读取和使用）
        this.authObj = decodeFromBase64(decodeURIComponent(urlParams));

        //console.log(this.authObj);

        if (this.authObj.token && this.authObj.type == '2') {
          localStorage.setItem('sx-token', this.authObj.token);
        } else {
          localStorage.removeItem('sx-token');
          this.$router.push({
            path: '/login?' + urlParams

          });
        }
        // 构建分页参数
        const params = {
          pageNo: isLoadMore ? this.pagination.currentPage + 1 : 1,
          pageSize: this.pagination.pageSize,
          robotId: this.authObj.robotId,
          column: 'createTime',
          order: 'desc'
        };

        api.getChatlist(params).then(res => {
          if (res.data && res.data.code == 200 && res.data.result) {
            const records = res.data.result.records || [];
            const total = res.data.result.total || 0;
            
            // 处理轮询和非轮询情况
            if (isPolling && !isLoadMore) {
              // 轮询时：保留现有顺序，只更新数据，有新消息的会话移到顶部
              const updatedIds = new Set();
              const recordsMap = new Map(records.map(item => [item.id, item]));
              
              // 找出有新消息的会话ID
              const sessionsWithNewMessages = [];
              
              // 更新现有会话数据
              for (let i = 0; i < this.chatlist.length; i++) {
                const existingSession = this.chatlist[i];
                const newData = recordsMap.get(existingSession.id);
                
                if (newData) {
                  updatedIds.add(existingSession.id);
                  
                  // 检查是否有新消息
                  const oldUnread = existingSession.unreadMessage || 0;
                  const newUnread = newData.unreadMessage || 0;
                  
                  // 更新会话数据
                  this.$set(this.chatlist, i, {
                    ...existingSession,
                    ...newData
                  });
                  
                  // 如果有新消息，记录会话
                  if (newUnread > oldUnread) {
                    sessionsWithNewMessages.push(this.chatlist[i]);
                  }
                }
              }
              
              // 处理新会话（之前不存在的会话）
              const newSessions = records.filter(item => !updatedIds.has(item.id));
              
              // 将有新消息的会话和新会话移到顶部
              if (sessionsWithNewMessages.length > 0 || newSessions.length > 0) {
                // 先移除有新消息的会话
                sessionsWithNewMessages.forEach(session => {
                  const index = this.chatlist.findIndex(item => item.id === session.id);
                  if (index !== -1) {
                    this.chatlist.splice(index, 1);
                  }
                });
                
                // 将有新消息的会话和新会话添加到顶部
                this.chatlist = [...sessionsWithNewMessages, ...newSessions, ...this.chatlist];
              }
            } else {
              // 非轮询时：正常排序
              // 先按未读消息数量降序排序，未读消息优先显示在顶部
              // 然后按updateTime降序排序，确保最新的会话显示在最前面，处理可能的null值
              const sortedRecords = records.sort((a, b) => {
                // 比较未读消息数量
                const unreadA = a.unreadMessage || 0;
                const unreadB = b.unreadMessage || 0;
                if (unreadA !== unreadB) {
                  return unreadB - unreadA;
                }
                // 如果未读消息数量相同，按更新时间排序
                const timeA = a.updateTime ? new Date(a.updateTime).getTime() : 0;
                const timeB = b.updateTime ? new Date(b.updateTime).getTime() : 0;
                return timeB - timeA;
              });

              // 处理数据拼接
              if (isLoadMore) {
                // 避免添加重复数据，通过id去重
                const existingIds = new Set(this.chatlist.map(item => item.id));
                const newRecords = sortedRecords.filter(item => !existingIds.has(item.id));
                this.chatlist = [...this.chatlist, ...newRecords];
                this.pagination.currentPage++;
              } else {
                this.chatlist = sortedRecords;
              }
            }

            // 更新分页状态
            this.pagination.total = total;
            this.pagination.hasMore = this.chatlist.length < total;

            // 首次加载且不是轮询时，默认选择已读消息的最上面一个
            if (!isLoadMore && !isPolling && this.chatlist.length > 0) {
              // 过滤出已读会话（unreadMessage为0）
              const readSessions = this.chatlist.filter(item => (item.unreadMessage || 0) === 0);
              if (readSessions.length > 0) {
                // 选择第一个已读会话
                const firstReadSession = readSessions[0];
                this.selectSession(firstReadSession.userId || firstReadSession.userid);
              }
            }
          } else {
            const errorMessage = res.data.message || '加载会话列表失败';
            console.error('Failed to load chatlist:', errorMessage);
            this.error = errorMessage;
            if (!isLoadMore) {
              this.chatlist = []; // 确保chatlist是数组
            }
          }
        }).catch(error => {
          console.error('Error loading chatlist:', error);
          this.error = '网络错误，无法加载会话列表';
          if (!isLoadMore) {
            this.chatlist = []; // 确保chatlist是数组
          }
        }).finally(() => {
          // 请求完成后无论成功失败都设置loading为false
          if (isLoadMore) {
            this.loadingMore = false;
          } else {
            this.loading = false;
          }
        })
      } catch (error) {

      }



    },
    // 加载更多会话
    loadMoreChatlist() {
      if (this.loadingMore || !this.pagination.hasMore) return;
      this.loadChatlist(true);
    },
    selectSession(userId) {
      if (!userId) return; // 确保userId有效
      this.selectId = userId
      // 标记为已读
      // 在本地取消小红点显示
      const sessionIndex = this.chatlist.findIndex(item => (item.userId || item.userid) === userId);
      if (sessionIndex !== -1) {
        this.$set(this.chatlist[sessionIndex], 'unreadMessage', 0);
        // 获取会话名称
        const session = this.chatlist[sessionIndex];
        const sessionName = session.firstName || session.userName;
        // 通知父组件切换会话，并传递会话名称
        this.$emit('session-change', userId, sessionName);
      } else {
        // 如果找不到会话，仍然通知父组件切换会话
        this.$emit('session-change', userId, '未知用户');
      }
    },
    getRandomAvatarColor(id) {
      // 使用id作为种子获取一致的随机颜色
      const seed = parseInt(id) || id.charCodeAt(0) || 0;
      const index = seed % this.avatarColors.length;
      return this.avatarColors[index];
    }
  },
  filters: {
    // 根据日期显示不同格式：当天显示时分，非当天显示月日，非当年显示年月日
    time(date) {
      if (!date) return '';
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      if (isNaN(dateObj.getTime())) return '';

      const now = new Date();
      const isToday = dateObj.toDateString() === now.toDateString();
      const isThisYear = dateObj.getFullYear() === now.getFullYear();

      if (isToday) {
        // 当天显示时分
        const hours = dateObj.getHours().toString().padStart(2, '0');
        const minutes = dateObj.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      } else if (isThisYear) {
        // 当年非当天显示月日
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${month}-${day}`;
      } else {
        // 非当年显示年月日
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    }
  },
}
</script>

<style lang="less" scoped>
.msglist {
  height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  width: 100%;
  box-sizing: border-box;

  /* 自定义滚动条 */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.03);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  .chat-ul {
    margin: 0;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .sessionlist {
    display: flex;
    padding: 5px 16px;
    transition: all 0.2s ease;
    align-items: flex-start;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);

    &:hover {
      background-color: rgba(0, 122, 255, 0.05);
      transform: translateX(2px);
    }

    &.active {
      background-color: rgba(0, 122, 255, 0.2);
      box-shadow: inset 4px 0 0 #0056b3, 0 2px 8px rgba(0, 122, 255, 0.3);
      border-bottom-color: rgba(0, 122, 255, 0.3);
    }
  .itemlist{
    display: flex;
    align-items: center;
  .list-left {
      position: relative;
      margin-right: 14px;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .avatar {
        border-radius: 10px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        transition: all 0.2s ease;
      }

      .avatar-text {
        width: 48px;
        height: 48px;
        background-color: #007aff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif;
        font-size: 22px;
        font-weight: 600;
        color: white;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 122, 255, 0.3);
        transition: all 0.2s ease;
      }

      .unread-count {
        position: absolute;
        top: -4px;
        right: -4px;
        background: linear-gradient(135deg, #ff3b30 0%, #ff6b6b 100%);
        border-radius: 50%;
        width: 6px;
        height: 6px;
        box-shadow: 0 2px 6px rgba(255, 59, 48, 0.4);
        // border: 2px solid white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 600;
        color: white;
      }
    }

    .list-right {
      flex: 1;
      min-width: 0;
      padding: 2px 0;

      .top-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
  
      }

      .name {
        font-size: 15px;
        font-weight: 600;
        color: #212529;
        margin-right: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif;

        .status {
          font-size: 11px;
          color: #34c759;
          margin-left: 6px;
          font-weight: 500;
          padding: 3px 8px;
          background-color: rgba(52, 199, 89, 0.1);
          border-radius: 12px;
          border: 1px solid rgba(52, 199, 89, 0.2);
        }
      }

      .time {
        color: #adb5bd;
        font-size: 11px;
        font-weight: 500;
        font-family: 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif;
      }

      .lastmsg {
        font-size: 13px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 2px;
        max-width: calc(100% - 30px);
        font-family: 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif;
      }
    }
  }
  
  }

  /* 空状态样式 */
  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    color: #999;
    font-size: 14px;
    text-align: center;

    .empty-content {
      width: 100%;
    }
  }

  /* 加载状态样式 */
  .loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #666;
    font-size: 14px;
  }

  /* 错误状态样式 */
  .error-state {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #ff3b30;
    font-size: 14px;
    text-align: center;

    .error-message {
      margin-bottom: 16px;
    }

    .retry-btn {
      padding: 6px 16px;
      background-color: #007aff;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #0056b3;
      }

      &:active {
        background-color: #004085;
      }
    }
  }

  /* 加载更多样式 */
  .load-more {
    display: flex;
    justify-content: center;
    padding: 15px;

    .load-more-btn {
      padding: 6px 20px;
      background-color: #007aff;
      color: white;
      border: none;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: #0056b3;
        transform: translateY(-1px);
      }

      &:active {
        background-color: #004085;
        transform: translateY(0);
      }
    }
  }

  /* 加载更多中样式 */
  .loading-more {
    display: flex;
    justify-content: center;
    padding: 15px;
    color: #666;
    font-size: 14px;
  }
}

/* 底部演示样式 */
.demo-section {
  margin-top: 20px;
  padding: 16px;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  text-align: center;

  .demo-text {
    font-size: 16px;
    color: #666;
    margin: 0;
  }
}
</style>
